import { render, staticRenderFns } from "./AccountNav.vue?vue&type=template&id=464c3689&scoped=true&"
import script from "./AccountNav.vue?vue&type=script&lang=js&"
export * from "./AccountNav.vue?vue&type=script&lang=js&"
import style0 from "./AccountNav.vue?vue&type=style&index=0&id=464c3689&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "464c3689",
  null
  
)

export default component.exports